import { useState } from "react";

import { Grid, Typography } from "@material-ui/core";

import { Toggle } from "../../../../components/toggle";
import { ByType } from "./ByType";
import { ByBuilding } from "./ByBuilding";

export const OperatingPowerAssetsTab = () => {
  const [tab, setTab] = useState("By type");
  const [isList, setIsList] = useState(true);

  return (
    <div>
      {isList ? (
        <Grid
          container
          style={{
            padding: "24px 0 20px",
          }}
        >
          <Typography
            style={{
              fontWeight: 700,
              textTransform: "uppercase",
              marginRight: 10,
            }}
          >
            Installed assets
          </Typography>
          <Toggle
            value={tab}
            options={["By type", "By building"]}
            onChanged={setTab}
            styles={{ width: 67 }}
          />
        </Grid>
      ) : null}
      {tab === "By type" ? (
        <ByType isList={isList} setIsList={setIsList} />
      ) : (
        <ByBuilding isList={isList} setIsList={setIsList} />
      )}
    </div>
  );
};
